// Larger calls (ClikMeet M5, cm-large): which faces are on screen. Only a face on screen has its video attached, and
// LiveKit's adaptive stream pauses every video no element shows — so these rules are also the cap on how many videos
// each person receives, the thing that keeps a 12-person call smooth on a phone. Pure: tested without a browser.

// Videos in the strip beside the main view; the rest are one "+N" tile. A phone takes two: two faces and the "+N" fit
// 390 px without scrolling (with three, "+N" was off the edge, under the self-view).
export const FILMSTRIP_MAX = { phone: 2, desk: 6 };

// Gallery page size: as many as fit at a readable size — 16 on a laptop (Meet's default), 9 on a small window. (A phone
// never shows the gallery: it has the main view and the strip.)
export function pageSize({ width }) {
  return width < 900 ? 9 : 16;
}

// One page of the gallery. `order` is everyone in join order, you first. Each person speaking who is on another page
// takes a place from the end of the page being looked at — so whoever talks is always seen, and nobody else moves
// (Zoom's rule). At most half the page is given up; the first place (you, on page one) never is. Answers
// { shown, page, pages }; the page is kept in range when people leave.
export function galleryPage({ order, speakers = [], page = 0, size }) {
  const n = Math.max(1, size);
  const pages = Math.max(1, Math.ceil(order.length / n));
  const at = Math.min(Math.max(0, page), pages - 1);
  const shown = order.slice(at * n, at * n + n);
  // In join order, not loudness: several talking at once keep their places instead of swapping at every level change.
  const away = order.filter((t) => speakers.includes(t.identity) && !shown.includes(t));
  const room = Math.min(away.length, Math.floor(shown.length / 2), Math.max(0, shown.length - 1));
  for (let i = 0; i < room; i++) shown[shown.length - 1 - i] = away[i];
  return { shown, page: at, pages };
}

// The strip beside the main view: at most `max` faces, the most recent speakers first (then join order); the others
// are counted, not drawn. Answers { shown, more }.
export function filmstrip({ list, lastSpoke = new Map(), max }) {
  const ranked = list.map((t, i) => ({ t, i, at: lastSpoke.get(t.identity) || 0 }))
    .sort((a, b) => (b.at - a.at) || (a.i - b.i)).map((x) => x.t);
  const keep = new Set(ranked.slice(0, Math.max(0, max)));
  return { shown: list.filter((t) => keep.has(t)), more: Math.max(0, list.length - keep.size) };
}
